export const APP_CONTENT_CLEAR_PHRASE = "WYCZYŚĆ DANE";
export const IRZ_PURGE_PHRASE = "USUŃ DANE IRZ";

export type AppContentStatus = {
  active: boolean;
  requested_at?: string | null;
  purge_at?: string | null;
  can_restore?: boolean | null;
};
